import { render, staticRenderFns } from "./AustlangMapVis.vue?vue&type=template&id=b84411da&scoped=true&"
import script from "./AustlangMapVis.vue?vue&type=script&lang=js&"
export * from "./AustlangMapVis.vue?vue&type=script&lang=js&"
import style0 from "./AustlangMapVis.vue?vue&type=style&index=0&id=b84411da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84411da",
  null
  
)

export default component.exports